import { Box, Flex, useRadio } from '@chakra-ui/react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const RadioButtonItem = (props: any) => {
  const { getInputProps, getRadioProps } = useRadio(props);

  const input = getInputProps();
  const checkbox = getRadioProps();

  return (
    <Box as="label" h="full">
      <input {...input} />
      <Flex
        justifyContent="center"
        alignItems="center"
        {...checkbox}
        cursor="pointer"
        borderWidth="1.5px"
        borderColor="brand.500"
        borderRadius="md"
        color="brand.500"
        width="full"
        _checked={{
          bg: 'brand.500',
          color: 'white',
        }}
        h="full"
        textAlign="center"
        px={2}
        py={5}
      >
        {props.children}
      </Flex>
    </Box>
  );
};
